// Счётчик непрочитанных на вкладке браузера: "(3) TG Client" в заголовке
// и красный бейдж с числом поверх favicon (как у веб-клиента Telegram).

const BASE_TITLE = "TG Client";
const BADGE_COLOR = "#e53935";

interface IconLinkState {
  link: HTMLLinkElement;
  href: string;
  type: string | null;
}

let originalLinks: IconLinkState[] | null = null;
let baseImagePromise: Promise<HTMLImageElement> | null = null;
let lastDrawnCount = -1;

const loadBaseIcon = (): Promise<HTMLImageElement> => {
  baseImagePromise ??= new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = "/favicon.png";
  });
  return baseImagePromise;
};

const iconLinks = (): HTMLLinkElement[] =>
  Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="icon"]'));

const rememberOriginals = (): void => {
  originalLinks ??= iconLinks().map((link) => ({
    link,
    href: link.href,
    type: link.getAttribute("type")
  }));
};

const restoreOriginals = (): void => {
  if (!originalLinks) {
    return;
  }
  for (const { link, href, type } of originalLinks) {
    link.href = href;
    if (type) {
      link.setAttribute("type", type);
    }
  }
};

const drawBadgeIcon = async (count: number): Promise<string> => {
  const base = await loadBaseIcon();
  const size = 64;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("canvas 2d context unavailable");
  }

  ctx.drawImage(base, 0, 0, size, size);

  const label = count > 99 ? "99+" : String(count);
  const radius = 19;
  const cx = size - radius - 1;
  const cy = size - radius - 1;
  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, Math.PI * 2);
  ctx.fillStyle = BADGE_COLOR;
  ctx.fill();

  ctx.fillStyle = "#fff";
  ctx.font = `bold ${label.length > 2 ? 18 : 24}px -apple-system, Roboto, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(label, cx, cy + 1);

  return canvas.toDataURL("image/png");
};

// Подпись аккаунта в заголовке вкладки — чтобы окна разных аккаунтов
// (мультиокно) различались в панели задач.
let accountTitleLabel = "";
let lastUnread = 0;
export const setTabAccountLabel = (label: string | null): void => {
  const next = label?.trim() ?? "";
  if (next === accountTitleLabel) return;
  accountTitleLabel = next;
  updateTabBadge(lastUnread);
};

export const updateTabBadge = (unread: number): void => {
  lastUnread = unread;
  if (typeof document === "undefined") {
    return;
  }

  const title = accountTitleLabel ? `${accountTitleLabel} — ${BASE_TITLE}` : BASE_TITLE;
  document.title = unread > 0 ? `(${unread}) ${title}` : title;

  if (unread === lastDrawnCount) {
    return;
  }
  lastDrawnCount = unread;

  if (unread <= 0) {
    restoreOriginals();
    return;
  }

  rememberOriginals();
  void drawBadgeIcon(unread)
    .then((dataUrl) => {
      // Пока рисовали, счётчик мог обнулиться — не затираем оригинал.
      if (lastDrawnCount !== unread) {
        return;
      }
      for (const link of iconLinks()) {
        link.setAttribute("type", "image/png");
        link.href = dataUrl;
      }
    })
    .catch(() => {
      // favicon не критичен: заголовок вкладки уже обновлён
    });
};
